import React from 'react';
import { TransactionsDashboard } from '../components/transactions';

const Transactions: React.FC = () => {
  return (
    <div className="p-6">
      <TransactionsDashboard />
    </div>
  );
};

export default Transactions; 